import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddBlogComponent } from './add-blog/add-blog.component';
import { BlogListComponent } from './blog-list/blog-list.component';
import { AdminSharedModule } from '../shared/shared.module';
import { RouterModule, Routes } from '@angular/router';
import { CoreModule } from '../../core/core.module';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CommonSharedModule } from '../../shared/shared.module';

const routes: Routes = [
  {
    path: '', children: [
      { path: '', component: BlogListComponent },
      { path: 'add', component: AddBlogComponent },
      { path: 'edit/:id', component: AddBlogComponent }
    ]
  }
];

@NgModule({
  declarations: [BlogListComponent, AddBlogComponent],
  imports: [
    CommonModule,
    CommonSharedModule,
    AdminSharedModule,
    CoreModule,
    RouterModule.forChild(routes),
    MatTableModule,
    MatTooltipModule
  ],
})
export class BlogModule { }
